<template>
  <li class="switcher">
    <SwitchPlan
      class="m-0"
      v-bind="switchProps"
      :switch-on-annual="switchOnAnnual"
      @switch-plans="handleSwitch"
    >
      <template #left-text>{{ leftText }}</template>
      <template #right-text>{{ rightText }}</template>
      <template #annual-discount>
        <span class="font-bold">{{ annualDiscount }}</span>
      </template>
    </SwitchPlan>
  </li>
</template>
<script>
import SwitchPlan from '@/components/PurchaseFlow/Plans/SwitchPlan';
export default {
  components: { SwitchPlan },
  props: {
    leftText: {
      type: String,
      required: true
    },
    rightText: {
      type: String,
      required: true
    },
    annualDiscount: {
      type: String,
      required: true
    },
    switchOnAnnual: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    switchProps() {
      return {
        activePillColor: 'var(--primary-color)',
        activePillTextColor: 'white',
        inactivePillTextColor: 'var(--secondary-color)',
        backgroundColor: 'var(--quaternary-color)',
        mobileBackgroundcolor: 'var(--quaternary-color)'
      };
    }
  },
  methods: {
    handleSwitch(value) {
      this.$emit('switch', value);
    }
  }
};
</script>
<style lang="scss" scoped>
.switcher {
  display: grid;
  align-content: start;
  font-size: 13px;
}
</style>
